module.exports = __webpack_public_path__ + "img/evalgreen.eb8c41e6.svg";